import { Http } from "@Services";
import { AccountModel } from "@Interfaces";

const signup = async (
    data: AccountModel.PostSignupRequest
): Promise<AccountModel.PostSignupResponse> => {
    let response: AccountModel.PostSignupResponse;

    try {
        response = await Http.Request<AccountModel.PostSignupResponse>({
            method: "POST",
            url: "/account/register",
            data,
        });
    } catch (error) {
        //  @ts-ignore
        throw Error(error);
    }

    return response;
};

export default signup;
